// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2fAPU","header":"Messages_header__1JDYa"};